import { useState } from "react";
import { useAuth } from "../../context/AuthContext";
import { apiError } from "../../lib/api";
import { Logo } from "../site/Logo";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";

export const AdminLogin = () => {
  const { login } = useAuth();
  const [userId, setUserId] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await login(userId, password);
    } catch (err) {
      setError(apiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-5" data-testid="admin-login-page">
      <div className="w-full max-w-md rounded-2xl border border-border bg-card p-8">
        <Logo />
        <h1 className="mt-8 font-serif text-3xl font-bold text-cream">Admin Login</h1>
        <p className="mt-2 text-sm text-muted-foreground">Manage menu, gallery, offers and café details.</p>
        <form onSubmit={submit} className="mt-8 space-y-5">
          <div>
            <Label htmlFor="user-id" className="text-xs uppercase tracking-[0.2em] text-muted-foreground">User ID</Label>
            <Input id="user-id" data-testid="admin-userid-input" value={userId} autoComplete="username"
              onChange={(e) => setUserId(e.target.value)} className="mt-2 bg-background" required />
          </div>
          <div>
            <Label htmlFor="password" className="text-xs uppercase tracking-[0.2em] text-muted-foreground">Password</Label>
            <Input id="password" type="password" data-testid="admin-password-input" value={password}
              autoComplete="current-password" onChange={(e) => setPassword(e.target.value)}
              className="mt-2 bg-background" required />
          </div>
          {error && (
            <p className="text-sm text-red-400" data-testid="admin-login-error">{error}</p>
          )}
          <Button type="submit" disabled={loading} data-testid="admin-login-submit"
            className="w-full rounded-full bg-copper font-semibold text-charcoal hover:bg-caramel">
            {loading ? "Signing in…" : "Sign In"}
          </Button>
        </form>
      </div>
    </div>
  );
};
